import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Placeholder, Modal } from "rsuite";
import Breadcrums from "../../common/breadcrumbs";
import * as productManagement from "../../services/productManagement";
import toHtml from "html-react-parser";
import { capitalizeFirstLetter, formateDateWithMonth, formateDateWithMonthAdmin, showStatus } from "../../../../utils/commonfunction";
import * as streamService from "../../services/stream.services";
import LiveStreamDetail from "../../../user/pages/LiveStreams/Detail";

const ViewStream = (props) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const params = useParams();
    const [showdefault, setShowDefault] = useState({});
    const [liveModalOpen, setLiveModalOpen] = useState(false);
    console.log(showdefault, "showdefaultttt");

    const breadcrumbs = [
        { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
        {
            title: t("sidebar_link_stream"),
            url: "/admin/stream/list/1",
        },
        { title: t("btn_view"), url: "" },
    ];

    useEffect(() => {
        let id = params.id;
        const formdata = new FormData();
        formdata.append("_id", id);
        streamService
            .Details(formdata)
            .then((response) => {
                console.log("View response-123", response);
                setShowDefault(response && response.data ? response.data : []);
            })
            .catch((error) => {
                console.log("error=====>", error);
            });
    }, [params.id]);

    return (
        <>
            <Breadcrums data={breadcrumbs} />
            <div className="row row-sm">
                <div className="col-lg-12 col-md-12 animation_fade">
                    <div className="card custom-card">
                        <div className="card-body">
                            <div>
                                <h6 className="main-content-label mb-3">
                                    {t('sidebar_link_stream')}
                                </h6>
                            </div>
                            {showdefault && Object.keys(showdefault).length > 0 ? (
                                <div className="row">
                                    <div className="col-lg-12 form-group">
                                        <table
                                            id="simple-table"
                                            className="table  table-bordered table-hover"
                                        >
                                            <tbody>

                                                <tr>
                                                    <th>{t("label_name")}</th>
                                                    <td className="text-capitalize">
                                                        {showdefault && showdefault.title
                                                            ? capitalizeFirstLetter(showdefault.title)
                                                            : "N/A"}
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <th>{t("label_description")}</th>
                                                    <td>
                                                        {showdefault && showdefault.description
                                                             ? capitalizeFirstLetter(showdefault.description)
                                                            : "N/A"}
                                                    </td>
                                                </tr>
                                                   <tr>
                                                    <th>{t("Seller ID")}</th>
                                                    <td>
                                                        {showdefault && showdefault.seller_id
                                                            ? showdefault.seller_id
                                                            : "N/A"}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>{t("label_store_name")}</th>
                                                    <td>
                                                        {showdefault && showdefault?.seller?.store_name
                                                            ? showdefault?.seller?.store_name
                                                            : "N/A"}
                                                    </td>
                                                </tr>
                                                   <tr>
                                                    <th>{t("Room ID")}</th>
                                                    <td>
                                                        {showdefault && showdefault.room_id
                                                            ? showdefault.room_id
                                                            : "N/A"}
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <th>{t("Duration")}</th>
                                                    <td>
                                                     {showdefault && showdefault.duration
                                                            ? showdefault.duration
                                                            : "N/A"}
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <th>{t("stream_type")}</th>
                                                    <td>
                                                     {showdefault && showdefault.stream_type
                                                            ? capitalizeFirstLetter(showdefault.stream_type)
                                                            : "N/A"}
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <th>{t("label_image")}</th>
                                                    <td><img src={showdefault && showdefault.thumbnail ? showdefault.thumbnail : ""} alt={showdefault?.title} style={{ height: "100px" }} /></td>
                                                </tr>
                                                <tr>
                                                    <th>{t("list_heading_date")}</th>
                                                    <td>
                                                        {showdefault && showdefault.date
                                                            ? formateDateWithMonthAdmin(showdefault.date)
                                                            : "N/A"}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>{t("stream_start_date")}</th>
                                                    <td>
                                                        {showdefault && showdefault.streamStartedAt
                                                            ? formateDateWithMonthAdmin(showdefault.streamStartedAt)
                                                            : "N/A"}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>{t("stream_end_date")}</th>
                                                    <td>
                                                        {showdefault && showdefault.streamEndedAt
                                                            ? formateDateWithMonthAdmin(showdefault.streamEndedAt)
                                                            : "N/A"}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>Watch Stream</th>
                                                    <td>
                                                        <div className="d-flex align-items-center gap-3 flex-wrap">
                                                            {showdefault?.isLive ? (
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-sm btn-success"
                                                                    style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}
                                                                    onClick={() => setLiveModalOpen(true)}
                                                                >
                                                                    <i className="ri-broadcast-line"></i>
                                                                    <span>Watch Live Stream</span>
                                                                </button>
                                                            ) : (showdefault?.recording_url || showdefault?.recorded_video) ? (
                                                                <span className="badge bg-primary px-3 py-2" style={{ fontSize: "13px" }}>
                                                                    <i className="ri-play-circle-line me-1"></i> Recorded Stream Available Below
                                                                </span>
                                                            ) : (
                                                                <span className="badge bg-secondary px-3 py-2" style={{ fontSize: "13px" }}>
                                                                    <i className="ri-information-line me-1"></i> {showdefault?.isStreamCompleted ? "Stream Ended (No recording saved)" : "Stream Pending / Scheduled"}
                                                                </span>
                                                            )}
                                                        </div>
                                                    </td>
                                                </tr>
                                                {(showdefault?.recording_url || showdefault?.recorded_video) && (
                                                    <tr>
                                                        <th>Recorded Stream Video</th>
                                                        <td>
                                                            <div className="d-flex flex-column gap-2" style={{ maxWidth: "480px" }}>
                                                                <video
                                                                    controls
                                                                    src={showdefault?.recording_url || showdefault?.recorded_video}
                                                                    style={{ width: "100%", maxHeight: "280px", borderRadius: "8px", backgroundColor: "#000" }}
                                                                />
                                                            </div>
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            ) : (
                                <Placeholder.Paragraph className="w-100" rowHeight={30} rowSpacing={5} active={true} rows={7} />
                            )}
                        </div>

                        <div className="card-body">
                            <div>
                                <h6 className="main-content-label mb-3">
                                    {t('sidebar_link_captions')}
                                </h6>
                            </div>
                            {showdefault && Object.keys(showdefault).length > 0 ? (
                                <div className="row">
                                    <div className="col-lg-12 form-group">
                                        <table
                                            id="simple-table"
                                            className="table  table-bordered "
                                        >
                                            <tbody>


                                                <tr>
                                               
                                                    <td>
                                                        {showdefault?.captions?.length > 0 ? (
                                                            showdefault.captions.map((item, index) => (
                                                                <div key={index} className="mb-2">
                                                                    <div className="font-semibold text-sm text-gray-700">
                                                                        Caption {index + 1}
                                                                    </div>
                                                                    <div className="text-gray-600">
                                                                        {item.text}
                                                                    </div>
                                                                </div>
                                                            ))
                                                        ) : (
                                                            "N/A"
                                                        )}
                                                    </td>
                                                </tr>

                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            ) : (
                                <Placeholder.Paragraph className="w-100" rowHeight={30} rowSpacing={5} active={true} rows={7} />
                            )}
                        </div>


                        <div className="mt-5 back-button">
                            <button
                                className="btn ripple btn-dark"
                                type="button"
                                onClick={() =>
                                    navigate("/admin/stream/list/1")
                                }
                            >
                                <i className="ace-icon-solid ion-arrow-return-left bigger-110 mx-1"></i>
                                {t("btn_back")}
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {/* Live Stream Playback Modal */}
            <Modal
                open={liveModalOpen}
                onClose={() => setLiveModalOpen(false)}
                size="lg"
                overflow={true}
            >
                <Modal.Header>
                    <Modal.Title className="d-flex align-items-center gap-2">
                        <i className="ri-broadcast-line text-success" style={{ fontSize: "22px" }}></i>
                        <span className="fw-bold">{showdefault?.title || "Live Stream"}</span>
                        <span className="badge bg-danger">LIVE</span>
                        {showdefault?.seller?.store_name && (
                            <span className="badge bg-light text-dark border">
                                <i className="ri-store-2-line me-1"></i>
                                {showdefault.seller.store_name}
                            </span>
                        )}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ maxHeight: "75vh", overflowY: "auto", padding: "16px" }}>
                    <div style={{ borderRadius: "10px", overflow: "hidden", minHeight: "450px" }}>
                        <LiveStreamDetail
                            publisherID={showdefault?.seller_id || showdefault?.seller?._id}
                            roomID={showdefault?.room_id}
                            streamId={showdefault?._id}
                            isEmbedded={true}
                        />
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button
                        type="button"
                        className="btn btn-sm btn-secondary"
                        onClick={() => setLiveModalOpen(false)}
                    >
                        Close
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default ViewStream;
